<template>
  <button
    type="button"
    class="copybtn"
    :data-done="copied ? '' : null"
    :aria-label="label"
    @click="copy"
  >
    <base-icon v-if="!copied" name="copy" />
    <base-icon v-else name="check" :width="2.4" />
    <span class="sr-only" aria-live="polite">{{ copied ? "کپی شد" : "" }}</span>
  </button>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";
import { copyText } from "@/utils/clipboard";

/**
 * Copy-to-clipboard affordance for the support number and the tracking code.
 *
 * The value is a prop read at click time, so a server-issued tracking code copies the
 * real code rather than a stale literal. Persian digits are converted back to Latin by
 * `copyText` — that is the form you paste into a form or dial.
 */
export default {
  name: "CopyButton",
  components: { BaseIcon },

  props: {
    value: { type: [String, Number], required: true },
    label: { type: String, default: "کپی" },
  },

  data() {
    return { copied: false };
  },

  beforeDestroy() {
    clearTimeout(this.resetTimer);
  },

  methods: {
    async copy() {
      const ok = await copyText(this.value);
      if (!ok) return;
      this.copied = true;
      this.$emit("copied");
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.copied = false;
      }, 1600);
    },
  },
};
</script>

<style scoped>
.copybtn {
  flex: 0 0 auto;
  display: inline-grid;
  place-items: center;
  width: 38px;
  height: 38px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 11px;
  color: var(--muted-foreground);
  cursor: pointer;
  font-family: inherit;
  transition: color 0.18s, border-color 0.18s;
  -webkit-tap-highlight-color: transparent;
}

.copybtn:hover {
  color: var(--foreground);
}

.copybtn >>> svg {
  width: 17px;
  height: 17px;
}

.copybtn[data-done] {
  color: var(--primary);
  border-color: var(--primary);
}
</style>
